import React from 'react';
import './footer.css';

const Footer = () => {
    return(
        <footer className="main-footer">
            <div className="footer-left">
                Copyright &copy; {new Date().getFullYear()}
            </div>
            <div className="footer-right">
                v2.0.0
            </div>
        </footer>
    )
}

export default Footer;